import {Box, Flex, Grid, Image, Space, Text} from "@mantine/core";
import {IconCheck} from "@tabler/icons-react";

import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';


const _ProductShowingResults = ({component}) => {

    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `#00000014 ${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}

        >
            <Text
                fz="18px"
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
                bg={component?.customize_styles?.text_decoration?.background_color}
                lh='1'
                fw={700}
            >
                {component?.customize_properties?.label}
            </Text>
            <Grid mt={12}>

                {
                    component?.items?.map((item, index) => (
                        <Grid.Col span={6} key={index}>
                            <Box
                                pos="relative"
                                mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}
                                bg={component?.customize_styles?.box_decoration?.background_color}
                                style={{
                                    boxShadow: `#00000014 ${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px`,
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                }}
                            >
                                <Image
                                    pos="relative"
                                    top={-30}
                                    left={0}
                                    right={0}
                                    mx="auto"
                                    fit="contain"
                                    src={item.image_url}
                                    fallbackSrc={ProductPlaceholderImage}
                                    // bg={component?.customize_styles?.image_decoration?.color}
                                    style={{ borderRadius: `${component?.customize_styles?.image_decoration?.radius}px` }}
                                />

                                <Box mt={-20}>
                                    <Flex align="center" justify="space-between">
                                        <Text
                                            c={component?.customize_styles?.product_price_text_decoration?.color}
                                            bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                            fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                            fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                            lh={1}
                                            translate="yes"
                                            lineClamp={1}
                                        >
                                            {item?.name}
                                        </Text>
                                        <Flex align="center" justify="center" c="#fff" bg="#0096f3" h={18} w={18} p={2} style={{ borderRadius: "50%" }}>
                                            <IconCheck/>
                                        </Flex>
                                    </Flex>
                                </Box>
                            </Box>
                            <Space h="xl"/>
                        </Grid.Col>
                    ))
                }
            </Grid>
        </Box>
    )
}
export default _ProductShowingResults;